// features/plans/data/platforms.ts
export const allPlatforms = [
  { id: "facebook", src: "/logo/fb-logo.svg" },
  { id: "twitter", src: "/logo/x-logo.svg" },
  { id: "instagram", src: "/logo/ig-logo.svg" },
  { id: "youtube", src: "/logo/yt-logo.svg" },
  { id: "reddit", src: "/logo/reddit-logo.svg" },
  { id: "tiktok", src: "/logo/tiktok-logo.svg" },
];
